import { FadeStack } from "@intelligems/ig-theme/animation/FadeStack";
import { useSelector } from "@src/store";
import { ExperienceBuilderSelector } from "@src/store/slices/experienceBuilder";
import { PageLoading } from "@src/features/experienceBuilder/pageState/PageLoading";
import { UnsupportedLocationError } from "@src/features/experienceBuilder/pageState/UnsupportedLocationError";
import { PluginNotDetectedError } from "@src/features/experienceBuilder/pageState/PluginNotDetectedError";
import { PluginVersionMismatchError } from "@src/features/experienceBuilder/pageState/PluginVersionMismatchError";
import { PluginCacheInvalidError } from "@src/features/experienceBuilder/pageState/PluginCacheInvalidError";
import { PageHtmlUnavailableError } from "@src/features/experienceBuilder/pageState/PageHtmlUnavailableError";
import { NetworkBlockedError } from "@src/features/experienceBuilder/pageState/NetworkBlockedError";

export const PageState = () => {
  const pageState = useSelector(ExperienceBuilderSelector.getPageState);
  const type = pageState?.type;
  const dismissed = useSelector(
    ExperienceBuilderSelector.isPageStateDismissed(type)
  );

  return (
    <FadeStack
      sx={{ position: "absolute", inset: 0, backgroundColor: "white" }}
    >
      {type === "loading" && !dismissed && <PageLoading />}
      {type === "proxyTimeout" && !dismissed && <UnsupportedLocationError />}
      {type === "pluginTimeout" && !dismissed && <PluginNotDetectedError />}
      {pageState?.type === "networkBlocked" && !dismissed && (
        <NetworkBlockedError url={pageState.url} />
      )}
      {type === "pluginMismatch" && !dismissed && (
        <PluginVersionMismatchError />
      )}
      {type === "pluginCacheInvalid" && !dismissed && (
        <PluginCacheInvalidError />
      )}
      {type === "pageHtmlUnavailable" && !dismissed && (
        <PageHtmlUnavailableError />
      )}
    </FadeStack>
  );
};
